export default __webpack_public_path__ + "static/media/icn-fuel-pistol-alt.7c1b13a7.svg";